<template>
  <div class="slide-scroll">
    <div class="slide-list-warp" ref="slideListWarp">
      <slot></slot>
    </div>
  </div>
</template>

<script>
// 自定义垂直滚动scoll
export default {
  name: 'SlideScroll',
  data () {
    return {
      timeInterval: null,
      currentPage: 0
    }
  },
  props: {
    pageCount: {
      type: Number,
      default: 0
    },
    speed: {
      type: Number,
      default: 3000
    },
    loop: {
      type: Boolean,
      default: false
    },
    slideHeight: {
      type: Number,
      default: 45
    }
  },
  mounted () {
    this.destroy()
    this.startScroll()
  },
  destroyed () {
    this.destroy()
  },
  methods: {
    startScroll () {
      this.timeInterval = setInterval(() => {
        this.timeScroll()
      }, this.speed)
    },
    timeScroll () {
      this.currentPage += 1
      this.$refs.slideListWarp.style.transition = `all 0.3s ease-in-out`
      this.$refs.slideListWarp.style.transform = `translate3d(0,${-this.slideHeight * this.currentPage}px,0)`
      if (this.currentPage >= this.pageCount) {
        clearInterval(this.timeInterval)
        let timeout = setTimeout(() => {
          this.$refs.slideListWarp.style.transition = `none`
          this.$refs.slideListWarp.style.transform = `translate3d(0,0,0)`
          if (this.loop) {
            clearTimeout(timeout)
            this.currentPage = 0
            this.startScroll()
          }
        }, 300)
      }
    },
    destroy () {
      if (this.timeInterval) clearInterval(this.timeInterval)
    }
  }
}
</script>

<style scoped>
  .slide-scroll{
    position: relative;
    height: 90px;
    overflow: hidden;
    background: #fff;
  }
  .slide-list-warp{
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
</style>
